import { render, staticRenderFns } from "./car.vue?vue&type=template&id=0f5cd1ce&scoped=true"
var script = {}
import style0 from "./car.vue?vue&type=style&index=0&id=0f5cd1ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5cd1ce",
  null
  
)

export default component.exports